import { Controller } from "@hotwired/stimulus"

// Opens this element as a Bootstrap modal the moment it lands in the DOM —
// used when a Turbo Stream broadcast injects a modal that must pop on its own,
// with no click (e.g. the live "steps received" confirmation on the fitness
// setup page, which a student scrolled to the bottom would otherwise miss).
export default class extends Controller {
  connect() {
    if (!window.bootstrap?.Modal) return
    this.modal = window.bootstrap.Modal.getOrCreateInstance(this.element)
    this.modal.show()
  }

  disconnect() {
    // The element may be yanked by a later broadcast or a Turbo navigation from
    // the CTA; tear the modal down and clear any orphaned backdrop / scroll lock
    // so the page isn't left dimmed or unscrollable.
    this.modal?.hide()
    this.modal?.dispose()
    document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
